const workExperienceData = [
    {
        company: 'Veeva Systems',
        position: 'Associate Frontend Engineer - UI Components',
        timeFrame: 'Aug 2025 - Present',
        description: [
            "Development and documentation of internal UI Component library used by 30+ teams at Veeva",
            "Shape library-wide API design decisions as one of the team’s go-to TypeScript experts",
            "Implement Passkey Authentication and Captcha for Veeva’s single sign-on solution",
        ],
    }, 
    {
        company: 'Veeva Systems',
        position: 'Frontend Engineering Intern - UI Components',
        timeFrame: 'Jun 2024 - Sep 2024',
        description: [
            "Upgraded UI Infrastructure to support deploying Storybook (UI Documentation) to AWS S3 for each build",
        ],
    }, 
    {
        company: 'IGN Entertainment',
        position: 'Frontend Engineering Intern',
        timeFrame: 'Jun 2022 - Aug 2022',
        description: [
            "Developed Google Optimize A/B tests ran on 1000+ users to improve site usability",
            "Independently built GraphQL backend support for game activity tracker for IGN hack day",
        ],
    }, 
    {
        company: 'Advantech',
        position: 'Information Technology Intern',
        timeFrame: 'Jul 2021 - Aug 2021',
        description: [
            "Implemented shell scripts to optimize and automate repetitive IT tasks",
        ],
    }, 
    {
        company: 'Include at Davis',
        position: 'President',
        timeFrame: 'Jun 2023 - Jun 2025',
        description: [
            "Rolled out in-house Content Management System, enabling clients to easily edit their websites",
            "Lead 25 developers in development of Content Management System & E-Store Framework",
        ],
    }, 
    {
        company: 'HackDavis',
        position: 'Technical Director',
        timeFrame: 'Oct 2023 - Jun 2025',
        description: [
            "Lead development of judging app used to collect and judge 150+ hackathon submissions",
            "Implementing secure user authentication system with JWT tokens for 1000 hackers",
        ],
    }, 
]

export default workExperienceData